// DS: i6.25 Studio Published
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioPublished: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.43 2.23a.8.8 0 0 1 1.13 0l4.57 4.57h-2.26L12 3.93 9.13 6.8H6.87l4.56-4.57ZM9.06 11.6a1.8 1.8 0 1 1 .01 3.6 1.8 1.8 0 0 1 0-3.6Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9Zm2 10v-9h14v9h-.5a1 1 0 0 0-.23-.42l-3.15-3.52a1 1 0 0 0-1.36-.12L8.6 19H5Z"
        />
      </svg>
    </IconWrap>
  );
};
StudioPublished.displayName = 'StudioPublished';

export default StudioPublished;
